import Banners from "../../components/Banner";

export default function BannersScreen(){
return <Banners />
}